import React, { useState } from 'react';
import { Route } from 'react-router-dom'

import { Home } from './pages/Home/Home'
import { Admin } from './pages/Admin';
import { Ajuda } from './pages/Ajuda'

import { Header } from './components/template/Header';
import { Nav } from './components/template/Nav';

import './styles/App.scss'
import './styles/Global.scss'
import './styles/Autocomplete.scss'

import { ArtigosByCategory } from './components/ArtigosByCategory';
import { OpenArticle } from './components/OpenArticle';
import ResultadoPesquisa from './components/ResultadoPesquisa';
import { Login } from './pages/Login';

function App() {

  const [statusApp, setStatusApp] = useState('appWithMenu')

  function toggleGridAppStyle() {
    if (statusApp === 'app') { setStatusApp('appWithMenu') } else { setStatusApp('app') }
  }

  return (
    <>
      <div className={statusApp}>
        <div className="Header">
          <Header gridAppStyle={toggleGridAppStyle} />
        </div>
        <div className="Nav">
          <Nav />
        </div>
        <div className="Main">        
            <Route path="/" exact component={Home} />
            <Route path="/admin" component={Admin} />
            <Route path="/ajuda" component={Ajuda} />
            <Route path={`/categoria/:id`} component={ArtigosByCategory} />
            <Route path={`/artigo/:id`} component={OpenArticle} />
            <Route path={`/resultado/:id`} component={ResultadoPesquisa} />
            <Route path="/login" component={Login} />         
         
        </div>
      </div>
    </>
  );
}

export default App;